import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loader from 'components/shared/Loader';
import MyForm from 'components/shared/form/MyForm';
import { required } from 'misc/validations';
import FileUpload from 'components/shared/form/FileUpload';
import TextArea from 'components/shared/form/TextArea';
import { getText, trackGA } from 'misc/helpers';
import { SAGA_SUPPORT_POST } from 'misc/types'; 


class Support extends Component {
    render = () => {
        const { customer } = this.props;

        let supportData = {
            customerId: customer.data.id,
            name: customer.data.firstName + " " + customer.data.lastName,
            email: customer.data.email,
            subject: "",
            message: undefined,
            screenshot: ""
        }
        
        return (
            <Loader>
                <div className="settings-view">
                    <h1>{getText('_12_3_Titel_support', 'Support')}</h1>

                    <MyForm
                        name="SupportForm"
                        sagaAction={SAGA_SUPPORT_POST}
                        buttonClasses="button-yellow button-medium"
                        initialValues={supportData}
                        submitLabel={getText('_12_3_text_support_send', 'Skicka')}
                    >

                        {/*
                        <InputField
                            name="subject"
                            type="text"
                            noStartWarning
                            validate={[required]}
                            placeholder={getText('Missing', 'Ämne')}
                        />
                        */}
                        
                        <TextArea name="message" validate={[required]} placeholder={getText('_12_3_text_support','Beskriv ditt ärende här')} />
                        <FileUpload 
                            name="screenshot" 
                            acceptedFiles="image/*" // Comma separated mime-types 
                            multiple={false} 
                        />
                    </MyForm>
                </div>
            </Loader>
        );
    };

    componentDidMount() {
        trackGA('12.3 Support');
    }
}





// Check if customer has pending email or mobile phone
// and set the appropriate values to the input fields
const mapStateToProps = (state, ownProps) => {
    let customer = state.customer;

    return {
        customer: customer,
        sessions: state.sessions
    };
};

export default connect(mapStateToProps)(Support);



// WEBPACK FOOTER //
// ./src/components/views/settings/Support.js